// extracted by mini-css-extract-plugin
module.exports = {"switchAccountErrorMessage":"SwitchAccount_switchAccountErrorMessage__3HzIF","switchAccountErrorMessageTitle":"SwitchAccount_switchAccountErrorMessageTitle__22kuH"};